export const ARC_SERVICE = import.meta.env.VITE_ARC_SERVICE;
export const PHISH_SERVICE = import.meta.env.VITE_PHISH_SERVICE;
export const PHISHING_SIMULATION = import.meta.env
  .VITE_PHISING_SIMULATION_SERVICE;
export const SAT_SERVICE = import.meta.env.VITE_SAT_SERVICE;
export const WEBFILTERING_SERVICE = import.meta.env.VITE_PHISH_SERVICE;
export const SEG_SERVICE = import.meta.env.VITE_SEG_SERVICE;

export type Solution =
  | typeof ARC_SERVICE
  | typeof PHISH_SERVICE
  | typeof PHISHING_SIMULATION
  | typeof SAT_SERVICE
  | typeof WEBFILTERING_SERVICE;

export const SERVICE_ICON = Object.freeze({
  ARC_SERVICE: "cl-icon-tabler-archive",
  PHISH_SERVICE: "cl-icon-tabler-mail",
  PHISHING_SIMULATION: "cl-icon-tabler-fish-hook",
  SAT_SERVICE: "cl-icon-tabler-school",
  WEBFILTERING_SERVICE: "cl-icon-tabler-world",
});

export interface AllServicesObject {
  uuid: string;
  menuItemLabel: string;
  tooltipLabel: string;
  tooltipLabelUnavailable: string;
  icon: string;
  customerDefaultRouteName: string;
  isServiceEnabled?: boolean;
}

export const ALL_SERVICES: Readonly<AllServicesObject[]> = Object.freeze([
  {
    uuid: PHISH_SERVICE,
    menuItemLabel: "menu-item-email-security-solution",
    tooltipLabel: "tooltip-phishtitan-solution",
    tooltipLabelUnavailable: "tooltip-no-email-security-license",
    icon: SERVICE_ICON.PHISH_SERVICE,
    customerDefaultRouteName: "customer-email_security",
    mspMenuItemTooltipUnavailable: "tooltip-no-email-security-yet",
  },
  {
    uuid: PHISHING_SIMULATION,
    menuItemLabel: "menu-item-phishing-simulation",
    tooltipLabel: "tooltip-phishing-simulation-solution",
    tooltipLabelUnavailable: "tooltip-no-phs-license",
    icon: SERVICE_ICON.PHISHING_SIMULATION,
    customerDefaultRouteName: "customer-phishing_simulation",
    mspMenuItemTooltipUnavailable: "tooltip-no-phs-yet",
  },
  {
    uuid: SAT_SERVICE,
    menuItemLabel: "menu-item-sat-solution",
    tooltipLabel: "tooltip-sat-solution",
    tooltipLabelUnavailable: "tooltip-no-sat-license",
    icon: SERVICE_ICON.SAT_SERVICE,
    customerDefaultRouteName: "customer-security_awareness_training",
    mspMenuItemTooltipUnavailable: "tooltip-no-sat-yet",
  },
  {
    uuid: ARC_SERVICE,
    menuItemLabel: "menu-item-arctitan-solution",
    tooltipLabel: "tooltip-arctitan-solution",
    tooltipLabelUnavailable: "tooltip-no-email-archiving-license",
    icon: SERVICE_ICON.ARC_SERVICE,
    customerDefaultRouteName: "customer-arc_titan",
    mspMenuItemTooltipUnavailable: "tooltip-no-email-archiving-yet",
  },
]);
